import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ListIcon from "@material-ui/icons/List";
import ListAltIcon from "@material-ui/icons/ListAlt";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SupervisorAccountSharpIcon from "@material-ui/icons/SupervisorAccountSharp";
import CategoryIcon from "@material-ui/icons/Category";
import { HelpSharp } from "@material-ui/icons";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import SignOut from "../auth/SignOut";
import { connect } from "react-redux";
import Routes from "../Routes";
import { List, ListItem, ListItemText } from "@material-ui/core";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import SettingsIcon from "@material-ui/icons/Settings";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% + ${drawerWidth}px)`,
    marginLeft: -drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1, 0),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  drawerRoot: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

function Navigation(props) {
  const classes = useStyles();

  const [visibilityLevel9, setvisibilityLevel9] = useState(false);
  const [visibilityLevel8, setvisibilityLevel8] = useState(false);
  const [visibilityLevel7, setvisibilityLevel7] = useState(false);

  useEffect(() => {
    function checkVisibility() {
      props.claims === "admin"
        ? setAdminVisiblity()
        : props.claims === "adminUser"
        ? setAdminUserVisiblity()
        : setServiceEngineerVisiblity();
    }
    checkVisibility();
    function setAdminVisiblity() {
      setvisibilityLevel9(true);
    }
    function setAdminUserVisiblity() {
      setvisibilityLevel8(true);
    }
    function setServiceEngineerVisiblity() {
      setvisibilityLevel7(true);
    }
  }, [props.claims]);

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root} style={{ maxWidth: "100%" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          {/*<Box display="flex" flexGrow={1}>
             whatever is on the left side */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {`${process.env.REACT_APP_NAME}`}{" "}
            {props.claims === "admin"
              ? "ADMIN"
              : props.claims === "adminUser"
              ? "ADMIN USER"
              : "SERVICE ENGINEER"}
          </Typography>
          {/*</Box>*/}
          <SignOut />
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
        onBackdropClick={handleDrawerClose}
      >
        <div className={classes.drawerHeader}>
          <Typography
            color="textPrimary"
            variant="button"
            Style={{ fontWeight: "bold" }}
          >
            {`${process.env.REACT_APP_NAME}`}{" "}
            {props.claims === "admin"
              ? "ADMIN"
              : props.claims === "adminUser"
              ? "ADMIN USER"
              : "SERVICE ENGINEER"}
          </Typography>{" "}
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes.drawerRoot}
        >
          <Link
            to="/account"
            style={{ color: "black", textDecoration: "none" }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Profile" />
            </ListItem>
          </Link>
          <Link
            to="/"
            style={{ color: "black", textDecoration: "none" }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <ListIcon />
              </ListItemIcon>
              <ListItemText primary="All Requests" />
            </ListItem>
          </Link>
          <Link
            to="/enquiries"
            style={{ color: "black", textDecoration: "none" }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <ListAltIcon />
              </ListItemIcon>
              <ListItemText primary="All Enquiries" />
            </ListItem>
          </Link>
          <Link
            to="/manageusers"
            style={{
              color: "black",
              textDecoration: "none",
              display: visibilityLevel9 ? "block" : "none",
            }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <SupervisorAccountSharpIcon />
              </ListItemIcon>
              <ListItemText primary="Manage Users" />
            </ListItem>
          </Link>
          <Link
            to="/categories"
            style={{
              color: "black",
              textDecoration: "none",
              display: visibilityLevel9 || visibilityLevel8 ? "block" : "none",
            }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <CategoryIcon />
              </ListItemIcon>
              <ListItemText primary="Categories" />
            </ListItem>
          </Link>
          <Link
            to="/payments"
            style={{
              color: "black",
              textDecoration: "none",
              display: visibilityLevel9 || visibilityLevel8 ? "block" : "none",
            }}
            onClick={handleDrawerClose}
          >
            <ListItem button>
              <ListItemIcon>
                <AccountBalanceWalletIcon />
              </ListItemIcon>
              <ListItemText primary="Payments" />
            </ListItem>
          </Link>
          <Divider />
          <Link
            to="/settings"
            style={{
              color: "black",
              textDecoration: "none",
              display: visibilityLevel9 || visibilityLevel8 ? "block" : "none",
            }}
            onClick={handleDrawerClose}
          >
            <ListItem button onClick={handleDrawerClose}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </ListItem>
          </Link>
        </List>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
        style={{ maxWidth: "100%" }}
      >
        <div className={classes.toolbar} />
        <div className={classes.drawerHeader} />
        {/* <div style={{ height: "500px" }}> */}
        <Routes />
        {/* </div> */}
      </main>
    </div>
  );
}

const mapStateToProps = (state) => state.authReducer;
export default connect(mapStateToProps)(Navigation);
